import { ProductDocsWidget } from '../../widgets/ProductDocsWidget';
import { SiteRoute } from '@journeyapps/package-types';
import * as React from 'react';
import { CrumbWidget } from '../../widgets/CrumbWidget';
import { ContentWidget } from '../../widgets/ContentWidget';
import { PageWidget } from '../../widgets/layout/PageWidget';
import { SectionWidget } from '../../widgets/layout/SectionWidget';
import { Link } from 'react-router';
import { ReactorBlurbWidget } from '../_shared/ReactorBlurbWidget';

const sector = require('../../../media/sector-cloud.png');

const img_bulk_edit = require('../../../media/sector/bulk-edit.jpg');
const img_changelogs = require('../../../media/sector/changelogs.jpg');
const img_oxide = require('../../../media/sector/oxide-embed.jpg');

export const SectorPage: React.FC = () => {
  return (
    <PageWidget width={1100} title="Sector">
      <ContentWidget>
        <h1>
          <CrumbWidget parts={['Platform stack', 'Sector']} />
        </h1>
        <p>
          Sector is the data browser for JourneyApps deployments. Backoffice teams use it at{' '}
          <a href="https://sector.journeyapps.com/">sector.journeyapps.com</a>, and developers use the same product
          inside OXIDE’s Browse Data workspace.
        </p>
        <img src={sector} />
        <SectionWidget
          index={1}
          image={img_bulk_edit}
          label="Bulk edit data"
          content={`
      Save time by bulk editing data everywhere across Sector. When ready, preview all final changes and apply them
      in a single operation.
      `}
        />
        <SectionWidget
          index={2}
          image={img_changelogs}
          ltr={false}
          label="Changelogs"
          content={`
       Make use of the Sector diff viewer to compare model changes through time with the use of per-model queries or entire DB lookups.
      `}
        />
        <SectionWidget
          index={3}
          image={img_oxide}
          label="Embedded in OXIDE"
          link={SiteRoute.OXIDE}
          content={`
       Not only is Sector standalone software, but it is also directly embedded inside of OXIDE, the platform IDE.
       Developers can browse deployment data directly from within OXIDE without having to leave their IDE.
      `}
        />
        <ReactorBlurbWidget name="Sector" />
        <ul>
          <li>Work with data in panels and in the Reactor workspace.</li>
          <li>Open multiple connections at the same time.</li>
          <li>Work with data fast due to caching and no page reload requirement.</li>
          <li>View data as tables, forms or even as JSON directly in the browser.</li>
          <li>Batch edit data in real-time and preview changes before bulk committing.</li>
        </ul>
        <h2>Sector is part of Labs</h2>
        <p>
          Sector is being developed over at JourneyApps Labs as an open initiative from the very beginning. Check out
          all the development activity <Link to="https://github.com/journeyapps-labs/sector">over at GitHub.</Link>
        </p>
      </ContentWidget>
      <ProductDocsWidget
        title="Work with your data in Sector"
        description="Connect to a deployment, find the records you need, and review changes."
        topics={['SECTOR']}
      />
    </PageWidget>
  );
};
